export class PersistenciaRequest {
  country: string;
  document: string;
  entityKey: string;
  name: string;
  domain: string;
  subdomain: string;
  matriz: any;
  user?: string;
  operation: string;
  fields?: any;
  requestId?: string;
  criterios?: any;

  constructor(
    country: string, document: string, entityKey: string, name: string,
    domain: string, subdomain: string, matriz: any,
    fields: string[], user: string, operation: string, requestId: string, criterios: any
  ) {
    this.country = country;
    this.document = document;
    this.entityKey = entityKey;
    this.name = name;
    this.domain = domain;
    this.subdomain = subdomain;
    this.matriz = matriz;
    this.user = user;
    this.operation = operation;
    this.fields = fields;
    this.requestId = requestId;
    this.criterios = criterios;
  }
}

export const objBodyPersistenciaDatos = (documento: number | string, entityKey: string, nombre: string, dominio: string, subdominio: string, matriz: string, usuario: string, fields: any, operation: string, requestId: string, criterios: string, comentarios: string, matchKey: string) => {
  return {
    "identifier": {
      "document": documento,
      "entityKey": entityKey,
      "name": nombre,
      "matchKey": matchKey
    },
    "operator": {
      "domain": dominio,
      "subdomain": subdominio,
      "matriz": matriz,
      "user": usuario
    },
    "changes": {
      "operation": operation,
      fields,
      "requestId": requestId,
      "criterios": criterios,
      comentarios
    }
  };
};
